import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {MenuService} from '../../../shared/menu.service';
import {PermissionManagementService} from '../permission-management.service';

@Injectable()
export class PermAdminUsersResolverService implements Resolve<void> {

    constructor(private readonly menuService: MenuService,
                private readonly permMgmtService: PermissionManagementService) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): void {
        this.permMgmtService.showMenu();
        this.permMgmtService.enableUserAssignments();
        this.menuService.disableMenu();
        this.menuService.disableTree();
    }
}
